import AdminDashboardLayout from '../layout/AdminDashboardLayout.vue'
import EEDashboardLayout    from '../layout/EEDashboardLayout.vue'
import EUDashboardLayout   from '../layout/EUDashboardLayout.vue'
import DefaultLayout        from '../layout/DefaultLayout.vue'

// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'



// Managers
import UserManager from '../usermanager'

function getRedirectRoute() {
  if( UserManager.isUserLoggedIn()) {
    if( UserManager.isAdmin() ) return "admin"
    if(UserManager.isHost())
      return "ppe_eu"
    return "ppe_ee"
  } 
  return "login"
}

const routes = [
  {
    path: '/remotecontroller',
    name: 'RemoteController',
    component: () => import('../pages/RemoteController.vue')
  },
  {
    path:'/',
    component : DefaultLayout,
    redirect:getRedirectRoute(),
    children: [
      {
        path: 'status',
        name: 'Status',
        component: () => import('../pages/Status.vue')
      },
      {
        path: 'login/:email?',
        name: 'Login',
        component: () => import('../pages/LoginPage.vue')
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('../pages/RegisterPage2.vue')
      },
      {
        path: 'reset',
        name: 'Reset',
        component: () => import('../pages/ResetPassword.vue')
      },
      {
        path: 'changepassword/:uniqueid',
        name: 'ChangePassword',
        component: () => import('../pages/ChangePassword.vue')
      },
    ]
  },
  {
    path: '/du',
    component: () => import('../layout/DuLayout.vue'),
    redirect: '/du/home',
    meta : { requiresAuth: true },
    children: [
      {
        path: 'home',
        name: 'DU_Home',
        component: ()=>import('../pages/du/duHome.vue')
      },
      {
        path: 'document/:id',
        name: 'DU_Document',
        component: ()=>import('../layout/DuDocumentLayout.vue'),
        redirect: '/du/document/:id/identity',
        children: [
          {
            path: 'identity',
            name: 'DU_DocumentIdentity',
            component: ()=>import('../pages/du/duIdentity.vue'),
          },
          {
            path: 'actions',
            name: 'DU_DocumentID',
            component: ()=>import('../pages/du/duDocument.vue'),
          }
        ]
      },
    ]
  },
  {
    path: '/ppe_eu',
    component: EUDashboardLayout,
    redirect: '/ppe_eu/operations',
    meta : { requiresAuth: true },
    children: [
      {
        path: 'home/:accountid?',
        name: 'EU_Home',
        component: () => import('../pages/ppe_eu/PPEHome.vue')
      },
      {
        path: 'operations/:accountid?',
        name: 'EU_Operations',
        component: () => import('../pages/ppe_eu/PPEOperations.vue')
      },
      {
        path: 'account/:id?',
        name: 'EU_Account',
        component: () => import('../pages/ppe_eu/A_Account.vue')
      },
      {
        path: 'company_eu/:companyId?',
        name: 'EU_B1',
        component: () => import('../pages/ppe_eu/B1_CompanyPageEU.vue')
      },
      {
        path: 'b2/:id',
        name: 'EU_B2',
        component: () => import('../pages/ppe_eu/B2.vue')
      },
      {
        path: 'b3/:id',
        name: 'EU_B3',
        component: () => import('../pages/ppe_eu/B3.vue')
      },
      {
        path: 'b2/:operationid/:companyid?',
        name: 'EU_B2_new',
        component: () => import('../pages/ppe_eu/B2.vue')
      },
      {
        path: 'operation/:accountid/:id?',
        name: 'EU_C_Operation',
        component: () => import('../pages/ppe_eu/C_Operation.vue')
      },
      {
        path: 'operation_home/:id',
        name: 'EU_C_OperationHome',
        component: () => import('../pages/ppe_eu/C_OperationHome.vue')
      },
      /*{
        path: 'd1/:id',
        name: 'EU_D1',
        component: () => import('../pages/ppe_eu/D1.vue')
      },*/
      {
        path: 'd3/:id',
        name: 'EU_D3',
        component: () => import('../pages/ppe_eu/D3.vue')
      },
      
    ],
  },
  {
    path: '/ppe_ee',
    component: EEDashboardLayout,
    redirect: '/ppe_ee/home',
    meta : { requiresAuth: true },
    children: [
      {
        path: 'home/:id?',
        name: 'homeId',
        component: () => import('../pages/ppe_ee/PPEHome.vue')
      },
      {
        path: 'account/:id?',
        name: 'accountId',
        component: () => import('../pages/ppe_ee/A_Account.vue')
      },
      {
        path: 'company_ee/:id?',
        name: 'B1_CompanyPageEEId',
        component: () => import('../pages/ppe_ee/B1_CompanyPageEE.vue')
      },
      {
        path: 'operation_ee/:accountid/:id',
        name: 'C_OperationEEId',
        component: () => import('../pages/ppe_ee/C_OperationEE.vue')
      },
      {
        path: 'operation_home_ee/:id',
        name: 'C_OperationHomeEE',
        component: () => import('../pages/ppe_ee/C_OperationHomeEE.vue')
      },
      {
        path: 'd0/:id',
        name: 'D0',
        component: () => import('../pages/ppe_ee/D0.vue')
      },
      {
        path: 'd1/:id',
        name: 'D1',
        component: () => import('../pages/ppe_ee/D1.vue')
      },
      {
        path: 'd3/:id',
        name: 'D3',
        component: () => import('../pages/ppe_ee/D3.vue')
      },
      {
        path: 'd4/:id',
        name: 'D4',
        component: () => import('../pages/ppe_ee/D4.vue')
      },

      
    ],
  },
  {
    path: '/admin',
    component: AdminDashboardLayout,
    redirect: '/admin/operations',
    meta : { requiresAuth: true, requiresAdmin:true },
    children: [
      {
        path: 'operations',
        name: 'operations',
        component: () => import('../pages/admin/Operations.vue')
      },
      {
        path: 'accounts',
        name: 'accounts',
        component: () => import('../pages/admin/Accounts.vue')
      },
      {
        path: 'companies',
        name: 'companies',
        component: () => import('../pages/admin/Companies.vue') 
      },
      {
        path: 'companies2',
        name: 'companies2',
        component: () => import('../pages/admin/Companies2.vue') 
      },
      {
        path: 'settings',
        name: 'settings',
        component: () => import('../pages/admin/Settings.vue')
      },
      {
        path: 'edittemplate/:template',
        name: 'edittemplate',
        component: () => import('../pages/admin/EditTemplate.vue')
      },
      {
        path: 'sendemail', // euid=? operationid=? eeid=?
        name: 'sendemail',
        component: () => import('../pages/admin/SendEmail.vue')
      },
      {
        path: 'company/:companyid', 
        name: 'company',
        component: () => import('../pages/admin/Company.vue')
      },
    ]
  },
  { path: '*', 
    component : DefaultLayout,
    redirect: '/404',
    children: [
      {
        path: '404',
        name: '404Error',
        component: NotFound
      }
    ]
    },
  //{ path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
